import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-password-step',
  templateUrl: './password-step.component.html',
  styleUrls: ['./password-step.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
})
export class PasswordStepComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() isLoading = false;
  @Input() errorText = '';
  @Input() isPasswordVisible = false;
  @Input() canResetPassword = false;

  @Output() submitted = new EventEmitter<void>();
  @Output() visibilityToggled = new EventEmitter<void>();
  @Output() backed = new EventEmitter<void>();
  @Output() forgotPasswordRequested = new EventEmitter<void>();
}
